import './StepIndicator.css';

/**
 * 結帳流程步驟條，購物車 / 結帳 / 完成 三個頁面共用。
 *
 * @param current   目前所在的步驟編號（1-based）
 * @param align     'left'（預設）｜'center'
 *
 * 用法：<StepIndicator current={2} />
 */
const STEPS = [
  { num: 1, label: '確認商品' },
  { num: 2, label: '配送與付款' },
  { num: 3, label: '完成訂單' },
];

function StepIndicator({ current = 1, align = 'left' }) {
  return (
    <div className="step-indicator" style={align === 'center' ? { justifyContent: 'center' } : undefined}>
      {STEPS.map((s, i) => {
        const state = current > s.num ? 'done' : current === s.num ? 'on' : '';
        return (
          <span key={s.num} style={{ display: 'inline-flex', alignItems: 'center', gap: 12 }}>
            <span className={`step ${state}`.trim()}>
              <span className="step-num">{s.num}</span>
              <span className="step-label">{s.label}</span>
            </span>
            {i < STEPS.length - 1 && (
              <span className={`step-line${current > s.num ? ' done' : ''}`}></span>
            )}
          </span>
        );
      })}
    </div>
  );
}

export default StepIndicator;
